import Vue from 'vue';
import Question from '@/components/questions/Question.vue';
import QuestionText from '@/components/questions/QuestionText.vue';

Vue.component('wes-question', Question);
Vue.component('wes-q-text', QuestionText);
